import { render, staticRenderFns } from "./Tecnologia.vue?vue&type=template&id=78b96c14&"
import script from "./Tecnologia.vue?vue&type=script&lang=ts&"
export * from "./Tecnologia.vue?vue&type=script&lang=ts&"
import style0 from "./Tecnologia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports